/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";

const CustomDialog = ({ isOpen, title, message, onConfirm, onClose }) => {
  const btn = css({
    padding: "5px 30px",
    backgroundColor: "#009043",
    color: "white",
    "&:hover": { backgroundColor: "#009043" },
  });

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onConfirm} css={btn} autoFocus>
          確認
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomDialog;
